import { ThemedChangePasswordPage as ChanagePassword } from "./change-password";
export const ThemedChangePasswordPage = ChanagePassword;
